export const DEFAULT_PRODUCT_IMAGE =
  "https://pub-138851153fab4021b8f49d4ea18f8eed.r2.dev/events_bg.jpeg";

export function cleanStatus(status: string): string {
  return status
    .trim()
    .replace(/[_\s]+/g, " ")
    .toLowerCase()
    .replace(/\b\p{L}/gu, (char) => char.toUpperCase());
}
